export const normalizePhoneNumber = (phoneNumber?: string) => {
  const phoneRegex = /[^+0-9]+/g; // remove all whitespace and hyphens
  return phoneNumber?.replaceAll(phoneRegex, '');
};
